import React from 'react';
import { Upload, message, Button } from 'antd';
import ArrowUpIcon from "../../../assets/images/icons/arrow_up.svg";
import { CloseRounded } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { toggleTour } from '../../../reducers/tourSlice';
import JSZip from 'jszip';

const { Dragger } = Upload;

const UploadMedia = ({ handleFileSelect, fileList, handelClick, disabled}) => {
     
    const dispatch = useDispatch();

    const beforeUpload = (file) => {    
        // Expected MIME types for ZIP files
        const expectedMimeTypes = ["application/zip", "application/x-zip-compressed"];
        
        // Check if the MIME type is one of the expected types
        if (!expectedMimeTypes.includes(file.type)) {
            message.error("Invalid file format. File must be a .zip file.");
            return Upload.LIST_IGNORE; // Ignore file if MIME type doesn't match
        }
    
        // Check if the file is not larger than 150MB
        if ((file.size / 1024 / 1024) > 150) {
            message.error('File must be smaller than 150MB');
            return Upload.LIST_IGNORE; // Ignore file if it's too large
        }

        // Check for special characters in file name (allowed characters: letters, numbers, dashes, and ampersands)
        const validFilenameRegex = /^[a-zA-Z0-9\-&_ ]+\.zip$/;
        if (!validFilenameRegex.test(file.name)) {
            message.error("File name contains invalid characters.");
            return Upload.LIST_IGNORE;
        }
    
        // Check and remove duplicate file based on name
        const isDuplicate = fileList.some(existingFile => existingFile.name === file.name);
        if (isDuplicate) {
            return Upload.LIST_IGNORE; // Ignore duplicate file
        }
    
        return true; // Allow upload if all checks pass
    };
    const handleFileChange = (file) => {
        const data = file.fileList.map(item => item.originFileObj ? item.originFileObj : item)
        handleFileSelect(data);
    };

    const customRequest = ({ file, onSuccess }) => {
        if (file && file.name) {
            onSuccess("ok");
        }
    }

    const onRemove = () => {
        handleFileSelect([]);
    }

    const handleClickOnDragger = () => {
        dispatch(toggleTour({ show: false }));
    }

    return (
        <Dragger className='pcvc-upload'
            fileList={fileList}
            multiple={false}
            beforeUpload={beforeUpload}
            onChange={handleFileChange}
            customRequest={customRequest}
            showUploadList={false}
            maxCount={1}
            onClick={handleClickOnDragger}
            disabled={fileList.length > 0}
        >
            <div className='upload-container'>
                {
                    fileList.length === 0 ?
                        <div className='upload-action'>
                            <div className='title'>Drag and drop here or</div>
                            <button className="btn-outlined">
                                <div className='btn-outlined-content'>
                                    <div className='text'>Upload documents </div>
                                    <img width={29} src={ArrowUpIcon} />
                                </div>
                            </button>
                        </div>
                        :
                        <div className="upload-action" style={{ zIndex: 9999 }} onClick={() => { return; }}>
                            <div className="selectedList">
                                <div className="name">{fileList[0].name}</div>
                                <CloseRounded className="remove" onClick={onRemove} />
                            </div>
                        </div>
                }
            </div>
            <div className="actions">
                <Button type="primary" onClick={handelClick} disabled={disabled}>
                    Submit
            </Button>
            </div>
        </Dragger>

    );
};

export default UploadMedia;
